import { atom } from 'recoil';

import storage from './storage1';
import { localStorageEffect, registerSyncAtom } from './recoil';

export enum THEMES {
  // light
  DEFAULT = 'default',
  DARK = 'dark',
  SYSTEM = 'system',
}

const defaultTheme = storage.theme?.theme || storage.theme || 'default';

export const themeState = atom({
  key: 'themeState',
  default: defaultTheme,
  effects_UNSTABLE: [localStorageEffect('theme')],
});

registerSyncAtom('theme', themeState);

export const loadTheme = (theme = defaultTheme) => {
  const rootElement = document.documentElement || document.querySelector<HTMLElement>('html');

  rootElement.setAttribute('theme', theme);
};

loadTheme();

export default loadTheme;
